import UserReportTable from './UserReportTable'

export default UserReportTable
